import styled from "styled-components";
import { palette, font, size } from "styled-theme";
import { isIE11 } from "@utils/helpers/browserHelper";

const Wrapper = styled.div`
  .modalContent div,
  .modalContent h1,
  .modalContent h2,
  .modalContent h3,
  .modalContent h4,
  .modalContent h5,
  .modalContent h6,
  .modalContent p {
    font-family: Arial !important;
  }
  .nccp-act {
    font-style: italic;
  }
  .small-loan-warning-asterix {
    font-family: Arial;
    font-size: 14px;
  }
  a {
    color: ${palette("modal", 0)};
    text-decoration: none;
    font-weight: ${font("headingWeight")};
    font-size: ${size("validationFontSize")};
  }
  a:focus {
    text-decoration: underline;
  }
  .sub-text {
    font-size: 12px;
    color: #aaa;
  }
  .label-text {
    font-size: 13px;
    color: #7b7b7b;
    line-height: 16px;
    margin-bottom: 0px;
  }
  ul {
    padding-left: 20px;
    margin-bottom: 15px;
    display: block;
    list-style-type: disc;
  }
  .modalContent {
    padding: 22px 16px 8px;
  }
  #sacc-warn-h1 {
    display: flex;
    color: ${palette("modal", 0)};
    font-weight: 400;
    padding-bottom: 4px;
    
    ${isIE11 && `
      height: 19px;
    `}
  }
  #sacc-warn-h1 .icon {
    align-self: center;
    padding-right: 13px;
  }
  .icon {
    width: 19px;
  }
  .title {
    padding-left: 10px;
  }
  h1 {
    font-weight: normal;
    font-size: 18px;
    color: ${palette("color", 17)};
    padding-bottom: 15px;
}
`;

export default Wrapper;
